// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2679":"b4129460d80eddaa","4459":"da08eaef53cc7956","7612":"81ea519c94492f8e"}[chunkId] + ".css";
};